import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      //
    }
  },
  computed: {
    ...mapGetters(['userRole', 'appSavitarna']),
    roleDT() {
      return this.roleOr([
        'DT_notaras',
        'DT_notaro_padejejas',
        'DT_notaro_atstovas',
        'DT_teismas',
        'DT_antstolis',
        'DT_kita_institucija',
        'DT_JA',
      ])
    },
    roleATK() {
      return this.roleOr(['DT_teismas', 'DT_antstolis', 'DT_kita_institucija'])
    },
    roleRG() {
      return this.roleOr(['RG_STSR_registrat', 'RG_NTR_registrat'])
    },
    roleEL() {
      return this.roleOr(['EL_JA', 'EL_FA'])
    },
    roleRGV() {
      return (
        this.roleOr([
          'RG_STSR_registrat',
          'RG_NTR_registrat',
          'RG_NTR_vadovas',
        ]) && !this.appSavitarna
      )
    },
    roleRGVadovas() {
      return this.role(['RG_NTR_vadovas']) && !this.appSavitarna
    },
    rolePaieska() {
      return this.roleOr([
        'P_S_pagal_JA',
        'P_S_pagal_FA',
        'P_S_pagal_turta',
        'P_I_pagal_ID',
        'P_IA_pagal_ID',
        'P_IT_pagal_ID',
        'P_IAT_pagal_ID',
        'P_TZ_pagal_JA',
        'P_TZ_pagal_FA',
        'P_TZ_pagal_turta',
      ])
    },
    roleSkaitytojas() {
      return this.role(['SK_skaitytojas']) && !this.roleRG && !this.roleDT
    },
    roleNotaras() {
      return this.roleOr([
        'DT_notaras',
        'DT_notaro_padejejas',
        'DT_notaro_atstovas',
      ])
    },
    roleNone() {
      return this.userRole.length === 0
    },
    appTitle() {
      return this.roleRG || this.roleSkaitytojas
        ? 'Registratoriaus darbo vieta'
        : 'Duomenų teikėjo darbo vieta'
    },
  },
  methods: {
    role(checkRole) {
      let roleList = Array.isArray(checkRole) ? checkRole : [checkRole]
      return roleList.every(item => {
        return this.userRole.includes(item)
      })
    },
    roleOr(checkRole) {
      let roleList = Array.isArray(checkRole) ? checkRole : [checkRole]
      return roleList.some(item => {
        return this.userRole.includes(item)
      })
    },
  },
}
